import styled from "styled-components";
import COLORS from "shared/constants/colors";
const Container = styled.div``;
const Wrapper = styled.div``;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  background: #fff;
  align-items: center;
  h2 {
    font-weight: normal;
    margin: 0;
    flex: 1;
  }
  > div {
    flex: 1;
  }
`;
const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 15px;
  max-width: 500px;
  width: 100%;
  margin-left: 15px;
`;
const Clear = styled.div`
  background-color: #000;
  color: #ffffff;
  border-radius: 3px;
  padding: 9px 13px;
`;

const UserEmail = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  font-size: 14px;
  > div {
    padding-left: 5px;
    p {
      margin: 0;
      :last-child {
        font-size: 13px;
      }
    }
  }
`;

const SwitchWrapper = styled.div`
  .MuiSwitch-colorPrimary.Mui-checked {
    color: ${COLORS.GREEN};
  }
  .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track {
    background-color: ${COLORS.GREEN};
  }
`;
const TabsWrapper = styled.div`
  .MuiTab-wrapper {
    font-weight: 600;
  }
  .MuiTab-textColorInherit.Mui-selected {
    color: #000;
  }
  .MuiTab-textColorInherit {
    color: rgba(0, 0, 0, 0.54);
    opacity: 1;
  }
  .MuiTabs-indicator {
    background-color: #000;
  }
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: left;
  margin-bottom: 20px;
  grid-gap: 20px;
`;

const Title = styled.div`
  color: #343a40;
  font-weight: bold;
  font-size: 16px;
  padding-bottom: 4px;
`;

const SubTitle = styled.div`
  font-size: 18px;
`;

const DecisionTitle = styled.h2`
  color: #000;
  text-align: left;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  margin-bottom: 20px;
`;

const Filters = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 5px;
  p {
    text-align: center;
    background: #000;
    color: #fff;
    padding: 5px 10px;
    border-radius: 15px;
    margin: 10px 0;
    cursor: pointer;
    font-weight: bold;
    font-size: 12px;
  }
`;

export {
  Container,
  Wrapper,
  Header,
  SearchWrapper,
  Clear,
  UserEmail,
  SwitchWrapper,
  TabsWrapper,
  Row,
  Title,
  SubTitle,
  DecisionTitle,
  Filters,
};
